import { message } from "antd";

export const openMessage = ( data ) => {
    message.config({
        top: '90%',

    })
    message[data.type](data.message);
}